export default function (selector, leave) {
    let elements = document.querySelectorAll(selector);

    elements.forEach(function (item, index) {
        if(index !== leave){
            item.remove();
        }
    })
}